// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"72924625","637":"af7c0343"}[chunkId] + ".chunk.js";
};